import ToggleBlock from './ToggleBlock';
import { ToggleBlockProps, ToggleBlockValueProps } from './types';

export type { ToggleBlockProps, ToggleBlockValueProps };
export default ToggleBlock;
